import { useParams } from 'react-router-dom'

import { useUserInfoStore } from '@/stores/user/userInfoStore'
import type { UserInterface } from '@/types'
import {
  canManageOrganisationUsers,
  getAssignableRoleOptions,
} from '@/utils/organisation/organisationUsersAccess'

export const useUsersAccess = () => {
  const selectedOrganisation = useUserInfoStore(
    (state) => state.selectedOrganisation
  )
  const organisation = useUserInfoStore((state) => state.organisation)
  const currentUser = useUserInfoStore((state) => state.currentUser)
  const tokenRoles = useUserInfoStore((state) => state.tokenRoles)
  const { code } = useParams()

  const isSelectedOrganisation =
    Object.keys(selectedOrganisation).length > 0 &&
    Number(code) == selectedOrganisation.code
  const org = isSelectedOrganisation ? selectedOrganisation : organisation
  const usersTarget = {
    tokenRoles,
    organisation: org,
    isOwnOrganisation: !isSelectedOrganisation,
  }
  const canManageUsers = canManageOrganisationUsers(usersTarget)

  return {
    organisationCode: org.code,
    isSelectedOrganisation,
    canManageUsers,
    roleOptions: canManageUsers ? getAssignableRoleOptions(usersTarget) : [],
    canEditUser: (user: UserInterface) =>
      canManageUsers || user.id === currentUser?.id,
  }
}
